module.exports = __webpack_public_path__ + "static/media/pinkTheme-girl.9fdad606.svg";